export default __webpack_public_path__ + "static/media/cross.66a86f73.svg";